"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _crmApi = require("@ys/crm-api");
var _file = require("@ys/utils/lib/file");
var _file2 = require("@/constants/file");
var _default = exports.default = {
  name: 'CommentAdd',
  props: {
    assId: {
      type: String,
      required: true
    },
    assType: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      uploading: false,
      form: {
        content: '',
        fileList: []
      }
    };
  },
  computed: {
    title() {
      const {
        parentUserName
      } = this.form;
      return parentUserName ? `回复${parentUserName}` : '评论';
    }
  },
  methods: {
    add(params) {
      this.form = {
        ...this.form,
        ...params
      };
      this.visible = true;
    },
    close() {
      this.form = {
        content: '',
        fileList: []
      };
      this.visible = false;
    },
    async submit() {
      this.loading = true;
      try {
        await _crmApi.YcAreaConfigService.postCommentAdd({
          body: {
            ...this.form,
            fileList: this.form.fileList.map(file => ({
              name: file.name,
              path: file.response,
              type: _file2.FileType.Comment,
              fileType: (0, _file.getExtension)(file.name)
            })),
            assId: this.assId,
            assType: this.assType
          }
        });
        this.$emit('refresh');
        this.$refs.form.resetFields();
        this.close();
      } finally {
        this.loading = false;
      }
    },
    handleUploadChange(e) {
      this.form.fileList = e.fileList.filter(item => item.response?.data).map(file => {
        const res = file.response?.data;
        return {
          name: res.originalName,
          path: res.link,
          fileType: (0, _file.getExtension)(file),
          type: _file2.FileType.Comment
        };
      });
    }
  }
};